import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { JsonFormStructure } from 'src/app/core/models/vs-models/json-form.model';
import { CommonApiErrorsHandler } from 'src/app/core/services/common-api-errors-handler.service';
import { catchError } from 'rxjs';
import { AccessSessionStorage } from './session-storage.service';
import { ApiHandlingService } from './api-handler.service';
import { requestType } from '../../models/vs-models/api-service-options.model';
import { ApiEndpoints } from '../../models/vs-models/all-urls.model';
import { UserDetails } from '../../models/vs-models/user-details.model';

@Injectable({
  providedIn: 'root'
})
export class navDataService {
    userDetails: UserDetails = JSON.parse(this.sessionStorage.getLoginSessionData('userDetails'));
    email=this.userDetails.email;
    loadedNavigation:any=[];
    constructor( private sessionStorage: AccessSessionStorage,private apiHandle: ApiHandlingService){}
    test(){
        return [
          {
            "id": 13,
            "label": "Admin Dashboard",
            "icon": "bx-home-circle",
            "link": "dashboard/admin",
            "valid": true,
            "subItems": [
              {
                "id": 14,
                "label": "View Dashboard",
                "icon": "bx - ixon",
                "link": "admin-dashboard",
                "valid": true,
                "parentId": 13
              }
            ]
          },
          {
            "id": 15,
            "label": "Groups & Permissions",
            "icon": "gnp",
            "link": "gnp",
            "valid": true,
            "subItems": [
              {
                "id": 17,
                "label": "Add BackEnd Urls",
                "icon": "bx",
                "link": "url-settings",
                "valid": true,
                "parentId": 15
              },
              {
                "id": 18,
                "label": "Add UI Paths",
                "icon": "bxs",
                "link": "ui-url-settings",
                "valid": true,
                "parentId": 15
              },
              {
                "id": 19,
                "label": "Group Settings",
                "icon": "bx",
                "link": "groups",
                "valid": true,
                "parentId": 15
              },
              {
                "id": 20,
                "label": "Tag Settings",
                "icon": "bx bx-bs",
                "link": "tags",
                "valid": true,
                "parentId": 15
              }
            ]
          },
          {
            "id": 8,
            "label": "Bookings",
            "icon": "bx-plane",
            "link": "bookings",
            "valid": true,
            "subItems": []
          },
          {
            "id": 5,
            "label": "Dashboard",
            "icon": "bx bvs",
            "link": "statistics",
            "valid": true,
            "subItems": []
          },
          {
            "id": 11,
            "label": "Documents",
            "icon": "bxs-file-doc",
            "link": "dashboards/docs",
            "valid": true,
            "subItems": []
          }
        ]
      
}

loadCustomResponse() {
  return <any>this.getMenu();
}

getMenu() {
  
  this.apiHandle.getReq(
    requestType.METHOD_GET, ApiEndpoints.GET_CSTM_UI_URL+"?email="+this.email).subscribe(
        (renderFD:any) => {
          let cstmMenu = [];
          cstmMenu = renderFD;
          return cstmMenu;
          // return cstmMenu;
        });
}

loadData(){
  // alert(this.userDetails.email);
    let menuArray = [];
    this.userDetails = JSON.parse(this.sessionStorage.getLoginSessionData('userDetails'));
    this.email=this.userDetails.email;
    this.apiHandle.getReq(
      requestType.METHOD_GET, ApiEndpoints.GET_GRPID_BY_EMAIL+"/"+this.email+"?email="+this.email).subscribe(
          (responseFD: any) => {
            // alert(responseFD.grpNm);
            // alert(this.email);
            this.apiHandle.getReq(
              requestType.METHOD_GET, ApiEndpoints.GET_GRP_PRMS_BY_GRPID+"/"+responseFD.grpId+"?email="+this.email).subscribe(
                  (renderFD: any) => {
                     // menuArray = renderFD;
                    let i:number = 0;
                    renderFD.forEach(function (obj) {
                      let navItem ={};
                      let expand:boolean=false;
                      
                      obj['id']=i;
                      if(obj.prntId==0 && obj.forMenu==true && obj.valid==true){
                        navItem['id']=obj.id;
                        navItem['uiId']=obj.uiUrlId;
                        navItem['label']=obj.uiUrlLbl;
                        navItem['icon']=obj.uiUrlIcn;
                        navItem['link']=obj.uiUrlLnk;
                        navItem['valid']=obj.valid;
                        navItem['subItems']=[];
                        navItem['expand']=expand;
                        menuArray.push(navItem)
                      }
                      i=i+1;
                    });
                    renderFD.forEach(function (obj) {
                      if(obj.prntId!=0){
                        menuArray.forEach(function(miniObj){
                          let navItem ={};
                          if(miniObj.uiId==obj.prntId && obj.forMenu==true && obj.valid==true){
                            navItem['id']=obj.id;
                            navItem['label']=obj.uiUrlLbl;
                            navItem['icon']=obj.uiUrlIcn;
                            navItem['link']=obj.uiUrlLnk;
                            navItem['valid']=obj.valid;
                            navItem['parentId']=miniObj.id;
                            miniObj.subItems.push(navItem);
                            i=i+1;
                          }
                        })
                      }
                    });
                    menuArray.forEach(function (obj) {
                      if(obj['subItems'].length!=0){
                        obj.expand=true;
                      }
                    });
                    
                    
                    
                  });
      });
      this.loadedNavigation = menuArray;
      return menuArray;
  }
}